import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './FieldDescription.css'

/**
 * Field Description is the helper or hint text for a [Field](/components/field/).
 * It is styled to match the hint text used by Nord form controls such as
 * [Input](/components/input/).
 *
 * @status draft
 * @category form
 * @lightDom true
 *
 * @slot - Default slot for the description text.
 */
@customElement('nord-field-description')
export default class FieldDescription extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-field-description': FieldDescription
  }
}
